import * as React from 'react'
import * as st from './LicenseModal.module.scss'
import { Button } from '@amzn/dvui/dist/Button'
import { Modal } from '@amzn/dvui/dist/Modal'
import { StringMap, fillValues } from 'DVWebNodeUtils'
import { Milliseconds} from '../../../widgets/DVWebNodeSPA/utils/formatting'
import {
  DownloadStatusPayload,
} from '../UWPNotifier'
import { triggerPlayback } from '../triggers'

interface LicenseModalProps {
  strings: StringMap
  downloadStatus: DownloadStatusPayload,
  modalRef: React.RefObject<Modal>
}

export const LicenseModal = ({strings, downloadStatus, modalRef}: LicenseModalProps) => (
  <Modal modalId={downloadStatus.TitleId} className={st.confirmModal}
          ref={modalRef}
          footer={<><Button onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            triggerPlayback(downloadStatus.TitleId, downloadStatus.DownloadId)
            modalRef.current.close()
          }}>{strings.DV_WINAPP_PLAYMODAL_CTA}</Button><Button onClick={() => (modalRef.current.close())}>{strings.DV_WINAPP_PLAYMODAL_CANCEL}</Button></>}
          header={fillValues(strings.DV_WINAPP_PLAYMODAL_HEAD, { hours: String(Math.max(new Milliseconds(downloadStatus.LicenseExpireAfterFirstPlay).toHours(), 1))})}
        >{fillValues(strings.DV_WINAPP_PLAYMODAL_DESC, { hours: String(Math.max(new Milliseconds(downloadStatus.LicenseExpireAfterFirstPlay).toHours(), 1)) })}</Modal>
)